import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { ShortObject } from '../../project-misc/data/project/short-json-object';
import { User } from 'projects/core/src/lib/login/data/user';

@JsonObject('model.SalePeriod')
export class SalePeriod extends AbstractModel {

	@JsonProperty(Number, 'totalAmt')
	totalAmt?: number;

	@JsonProperty(Number, 'invoicedBalance')
	invoicedBalance?: number;

	@JsonProperty(Number, 'paymentsReceived')
	paymentsReceived?: number;

  @JsonProperty(String, 'startDate')
  startDate?: string;

  @JsonProperty(String, 'endDate')
  endDate?: string;

}
